// extracted by mini-css-extract-plugin
export default {"seatInfo":"SeatInfo_seatInfo__Vi0Vc","section":"SeatInfo_section__NBuxJ","row":"SeatInfo_row__3hT5Q","quantity":"SeatInfo_quantity__wK-4X","seats":"SeatInfo_seats__HY+9s"};